var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"eagle-root":""}},[_c('anchor-popup'),_c('eagle-system-bar'),(_vm.layoutReady)?_c('router-view'):_vm._e(),_c('eagle-snackbar'),_c('loading'),_c('progress-loading'),_c('vue-snotify')],1)}
var staticRenderFns = []

export { render, staticRenderFns }